export default "__VITE_ASSET__CRDQwiXe__"